import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

/**
 * Fetches one agent's compacted-history summaries (most recent `limit`).
 * A short simulation may have none at all — an empty array is normal, not an
 * error.
 */
const getSimulationAgentSummaries = (
  simulationId,
  agentConversationId,
  limit,
  callback,
  errorCallback,
) => {
  return async (dispatch) => {
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const reqId = uuidv4();
        try {
          const response = await axios.get(
            `/ads/admin/simulations/${simulationId}/agents/${agentConversationId}/summaries`,
            {
              params: {
                'request-id': reqId,
                limit: limit || 5,
              },
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );
          if (response.status === 200) {
            if (typeof callback === 'function') callback(response?.data || []);
          } else {
            if (typeof errorCallback === 'function')
              errorCallback('Failed to fetch agent summaries');
          }
        } catch (e) {
          if (typeof errorCallback === 'function')
            errorCallback(
              e?.response?.data?.message || 'Failed to fetch agent summaries',
            );
        }
        unsubscribe();
      });
    } catch (e) {
      if (typeof errorCallback === 'function')
        errorCallback('Failed to fetch agent summaries');
    }
  };
};

export default getSimulationAgentSummaries;
